import React from 'react';
import { FiServer, FiCloud, FiMonitor, FiShield } from 'react-icons/fi';
import './Services.css';

const services = [
  {
    icon: <FiServer size={28} />,
    title: 'Network Infrastructure',
    description:
      'Desain dan implementasi infrastruktur jaringan enterprise yang handal, scalable, dan aman untuk mendukung operasional bisnis Anda tanpa gangguan.',
  },
  {
    icon: <FiCloud size={28} />,
    title: 'Cloud Computing',
    description:
      'Migrasi dan pengelolaan cloud yang efisien dengan solusi hybrid dan multi-cloud untuk optimalisasi biaya dan performa bisnis Anda.',
  },
  {
    icon: <FiMonitor size={28} />,
    title: 'IT Managed Services',
    description:
      'Layanan pengelolaan IT end-to-end yang proaktif, mulai dari monitoring 24/7, maintenance, hingga helpdesk untuk menjaga kelangsungan bisnis.',
  },
  {
    icon: <FiShield size={28} />,
    title: 'Cyber Security',
    description:
      'Proteksi menyeluruh terhadap ancaman siber dengan solusi keamanan berlapis, penetration testing, dan compliance management.',
  },
];

const Services = () => {
  return (
    <section className="services section" id="layanan">
      <div className="container">
        <div className="services__header">
          <div className="services__header-left">
            <span className="section-label">Layanan Kami</span>
            <h2 className="section-title">
              Infrastruktur Komprehensif untuk Skalabilitas Tanpa Batas
            </h2>
          </div>
          <div className="services__header-right">
            <p className="section-subtitle">
              Dari perencanaan hingga pengelolaan berkelanjutan, kami menyediakan 
              solusi infrastruktur IT yang dirancang khusus untuk kebutuhan bisnis Anda.
            </p>
          </div>
        </div>

        <div className="services__grid">
          {services.map((service, index) => (
            <div key={index} className="services__card">
              <div className="services__card-icon">{service.icon}</div>
              <h3 className="services__card-title">{service.title}</h3>
              <p className="services__card-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
